import { useEffect, useRef } from 'react';

const useSmoothAudioUpdate = (onUpdate: (time: number) => void) => {
  const audioRef = useRef<HTMLAudioElement>(null);
  const requestRef = useRef<number | null>(null);
  const callbackRef = useRef(onUpdate);
  const lastTimeRef = useRef(0);

  useEffect(() => {
    callbackRef.current = onUpdate;
  }, [onUpdate]);

  useEffect(() => {
    const updateAudioTime = () => {
      const audio = audioRef.current;

      if (audio) {
        const currentTime = Math.floor(audio.currentTime * 10) / 10;

        // only update when time changes by 100ms
        if (currentTime !== lastTimeRef.current) {
          lastTimeRef.current = currentTime;
          callbackRef.current(currentTime);
        }
      }

      requestRef.current = requestAnimationFrame(updateAudioTime);
    };

    requestRef.current = requestAnimationFrame(updateAudioTime);

    return () => {
      if (requestRef.current !== null) {
        cancelAnimationFrame(requestRef.current);
      }
    };
  }, []);

  return audioRef;
};

export default useSmoothAudioUpdate;
